import React from "react";
import { useEffect, useState } from 'react';
import { Form, Button, Table, Col, Row, Container, Card } from 'react-bootstrap';
import { capitalizeFirstLetter, CharacterCount, validateRecords } from '../Shared/Helpers';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactDatetime from "react-datetime";

const StepSix = ({ handleNext, handleBack, storedData, stepNum }) => {

    const [signedName, setSignedName] = useState('');

    // ## HOOKS ##
    useEffect(() => {
        if (!isEmpty(storedData)) {
            setSignedName(storedData); // passed signed name
        }
    }, []);

    return (
        <Row>
            <Col sm={12} md={12}>
                <h2 >{stepNum} Declaration</h2>
                <p className="text-danger">Please sign below before proceeding.</p>
                <h5 style={{ fontWeight: 'normal', fontSize: '0.99rem' }}> I declare that the information I have given, is to the best of my knowledge true and complete. I understand that if I have knowingly provided false information or withheld relevant details,
                    this could lead to disqualification from appointment or dismissal without notice.
                </h5>
            </Col>

            <Col sm={12} md={6}>
                <Form.Group >
                    <Form.Label>Signed:</Form.Label>
                    <Form.Control
                        type="text"
                        maxLength="20"
                        className="form-control custom-input"
                        name="contact"
                        value={signedName}
                        onChange={(e) => setSignedName(e.target.value)}
                    />
                </Form.Group>
            </Col>

            <Col sm={12} md={6}>
                <Form.Group className="text-center">
                    <Form.Label>Date Stamp:</Form.Label>
                    <ReactDatetime
                        inputProps={{
                            className: "form-control custom-input",
                            name: "contact",
                            disabled: true
                        }} defaultValue={new Date()}
                        value={new Date()}
                    />
                </Form.Group>
            </Col>

            <Col sm={12} md={12} style={{ marginTop: '10px' }}>
                <p>We are an Equal Opportunities Employer and welcome applications from all sections of the community</p>
            </Col>


            <Row>
                <Col sm={12} className="d-flex justify-content-between mt-3">
                    <Button className="btn-lg btn-shadow" variamt="danger" onClick={handleBack}>Back</Button>
                    <Button className="btn-lg btn-shadow" variant="success" style={{ borderColor: '#FFFF' }} onClick={() => handleNext(signedName)} disabled={!signedName}>Next</Button>
                </Col>
            </Row>
        </Row>
    );
}

export default StepSix;
